import { sagaActionTypes, reduxActions, SagaAction } from '.';
import UploadFile, { UploadFileResponse } from '../../../components/shared/FileUpload/UploadFile';
import { SagaIterator } from 'redux-saga';
import { call, takeLatest, put } from 'redux-saga/effects';
import * as fileApi from '../../../api/uploadFile';
import { actions as appUIActions } from '../../uis/app';
import { rollbar } from 'src';

export default function* watchFilesData(): SagaIterator {
    yield takeLatest(sagaActionTypes.GET_FILES_BY_SOURCE_ASYNC, getFilesBySourceAsync);
    yield takeLatest(sagaActionTypes.ADD_NEW_FILES_ASYNC, addNewFilesBySourceAsync);
    yield takeLatest(sagaActionTypes.UPDATE_FILES_ASYNC, updateFilesBySourceAsync);
    yield takeLatest(sagaActionTypes.REMOVE_FILES_ASYNC, removeFilesBySourceAsync);
}

export function* getFilesBySourceAsync(action: SagaAction): SagaIterator {
    try {
        yield put(reduxActions.getFilesBySourceProcessing());
        const files: Array<UploadFile> = yield call(fileApi.getUploadFilesBySource, action.sourceId);
        yield put(reduxActions.getFilesBySourceSucceeded(files));
    } catch (e) {
        rollbar.error('Cannot get files!');
        yield put(reduxActions.getFilesBySourceFailed());
        yield call(console.log, 'Cannot get files!');
    }
}

export function* addNewFilesBySourceAsync(action: SagaAction): SagaIterator {
    try {
        yield put(reduxActions.addNewFilesProcessing());
        const response: UploadFileResponse = yield call(fileApi.addNewFilesBySource, action.filesRequest, action.sourceId);
        if (response.success) {
            yield put(reduxActions.addNewFilesSucceeded(response.files));
        }
        else {
            yield put(reduxActions.addNewFilesFailed());
            yield call(console.log, response.message);
        }

    } catch (e) {
        rollbar.error('Cannot add new files!');
        yield put(reduxActions.addNewFilesFailed());
        yield call(console.log, 'Cannot add new files!');
    }
}

export function* updateFilesBySourceAsync(action: SagaAction): SagaIterator {
    try {
        yield put(reduxActions.updateFilesProcessing());
        const response: UploadFileResponse = yield call(fileApi.updateFilesBySource, action.filesRequest, action.sourceId);

        if (response.success) {
            yield put(reduxActions.updateFilesSucceeded(response.files));
            yield put(appUIActions.setMessageIndicator('Update file success', 'success'));
        }
        else {
            yield put(reduxActions.updateFilesFailed());
            yield put(appUIActions.setMessageIndicator(response.message, 'error'));
        }

    } catch (e) {
        rollbar.error('Cannot update files!');
        yield put(reduxActions.updateFilesFailed());
        yield put(appUIActions.setMessageIndicator('Update file failed', 'error'));
        yield call(console.log, 'Cannot update files!');
    }
}

export function* removeFilesBySourceAsync(action: SagaAction): SagaIterator {
    try {
        yield put(reduxActions.removeFilesProcessing());
        const response: UploadFileResponse = yield call(fileApi.removeFile, action.fileId, action.sourceId);
        if (response.success) {
            yield put(reduxActions.removeFilesSucceeded(response.files));
            yield put(appUIActions.setMessageIndicator('Remove file success', 'success'));
        }
        else {
            yield put(reduxActions.removeFilesFailed());
            yield put(appUIActions.setMessageIndicator(response.message, 'error'));
        }

    } catch (e) {
        rollbar.error('Cannot remove files!');
        yield put(reduxActions.removeFilesFailed());
        yield put(appUIActions.setMessageIndicator('Remove file failed', 'success'));
        yield call(console.log, 'Cannot remove files!');
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/attachment/saga.ts